module.exports = __webpack_public_path__ + "static/img/business82.ca62aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business82.png
// module id = wh+4
// module chunks = 9